import styled from 'styled-components';
import { media } from '$util/theme';
import Grid from '$components/layout/Grid';

export default styled.div`
  position: relative;
  ${media.down('md')} {
    .Row {
      padding: 0 16px;
    }
  }
  ${media.up('md')} {
    height: 700px;

    .Row {
      padding: 0 80px;
    }

    .top-wrapper {
      padding-top: 54px;
      padding-bottom: 54px;
    }
  }
  ${media.up('lg')} {
    padding-top: 0;
    padding-bottom: 0;
    height: 650px;
  }
  ${media.up('xl')} {
    height: 694px;
  }

  .vrm-lookup-card {
    max-width: 525px;
  }

  /* NOTE: Temp overrides until VrmLookup is refactored */
  .input-group > .ant-form-item {
    &.vrm,
    &.postcode {
      width: 100%;
      padding: 0 !important;
    }
  }
`;

export const AntGrid = styled(Grid)``;

export const StyledPicture = styled.picture`
  display: block;
  box-sizing: border-box;

  ${media.up('md')} {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;

    > img {
      display: block;
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }
`;
